const mainPageBrandsSections = [
  {
    title: "Featured Brands",
    description: "Discover premium ammunition from industry-leading brands.",
    logos: [
      {
        link: "/brands/aguila",
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Aguila_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Aguila_W.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Armscor_B_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Armscor_W.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Barnes_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Barnes_W.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Blazer_B_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Blazer_W_A.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Federal_C_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Federal_W_A.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Fiocchi_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Fiocchi_W.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Magtech_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Magtech_W.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/PMC_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/PMC_W.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Remington_C.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Remington_W.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Sig Sauer_B_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/2024-08-12/Sig Sauer_W_A.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Speer_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Speer_W.png",
      },
      {
        white: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Tulammo_C.png",
        black: "https://d337jieq2masmw.cloudfront.net/2024-08-12/Tulammo_W.png",
      },
    ],
  },
  {
    title: "Featured Vendors",
    description:
      "Shop with confidence from trusted ammunition vendors and suppliers.",
    logos: [
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/TargetSportsLightMode.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/2NY_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/American%20Marksman_Colored.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/American%20Marksman_White.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Ammo%20Hero_Black_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Ammo%20Hero_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Bass%20Pro%20Shops_Colored_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Bass%20Pro%20Shops_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Billet%20Bob_C_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Billet%20Bob_W_A.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Blackout%20Club_Colored_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Blackout%20Club_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Cabelas_Colored.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Cabelas_White.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Gun%20Prime_Black_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Gun%20Prime_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/KIR%20AMMO_Colored_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/KIR%20AMMO_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Palmetto_Colored_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Palmetto_White_W%20Art.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/PNR%20Ammo_C_A.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/PNR%20Ammo_W_A.png",
      },
      {
        white:
          "https://d337jieq2masmw.cloudfront.net/light_mode_vendors/Saint%20Barbs%20Bullets_Black_W%20Art.png",
        black:
          "https://d337jieq2masmw.cloudfront.net/Dark_mode_vendors/Saint%20Barbs%20Bullets_White.png",
      },
    ],
  },
];

export default mainPageBrandsSections;


